export default __webpack_public_path__ + "static/ISO-9001-48c7d43274f246a83553720add51029b.png";